import { iconCredit, iconCalculator, iconPreAprobador } from '../defaultValues';

const data = {
    role_1922665e7b584eb19c224ef09f75a84e: [
        {
            id: 'solicitudes-credito',
            icon: iconCredit,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'pre-aprobador',
            icon: iconPreAprobador,
            label: 'Pre-aprobador',
            to: '/app/pre-aprobador',
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
        },
    ],
};
export default data;
